import { gql } from "apollo-boost";

export const TRACK_BOOKING_FUNNEL_STEP = gql`
  mutation trackBookingFunnelStep($input: TrackBookingFunnelStepInput!) {
    trackBookingFunnelStep(input: $input) {
      success
    }
  }
`;
